import { render, staticRenderFns } from "./brand-modal.vue?vue&type=template&id=77a81bd1&scoped=true"
import script from "./brand-modal.vue?vue&type=script&lang=js"
export * from "./brand-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a81bd1",
  null
  
)

export default component.exports